import React from "react";

import { Flex, IconLinkButton } from "components";

type CropMixComposerInfoSectionProps = {
  headline: string;
  content: string | React.ReactNode;
  info: string;
  onInfoClicked: (clicked: boolean) => void;
  dataTestId?: string;
  className?: string;
};
export const CropMixComposerInfoSection = ({ headline, content, info, onInfoClicked, dataTestId, className }: CropMixComposerInfoSectionProps) => (
  <Flex className={className} style={{ paddingTop: "4.5rem", paddingLeft: "4rem" }} vertical={true}>
    <h1 data-testid={`crop-mix-composer-overlay-step-${dataTestId}-info-headline`}>{headline}</h1>
    <p data-testid={`crop-mix-composer-overlay-step-${dataTestId}-info-content`} className="paragraph-m">
      {content}
    </p>
    <IconLinkButton
      dataTestId="crop-mix-composer-overlay-footer-info-icon-button"
      className="field-timeline-payout-info-icon-button"
      iconType="info"
      size="small"
      text={info}
      onClick={() => onInfoClicked(true)}
    />
  </Flex>
);
